export const ExistingCustomerCardSelectionType = {
  NONE: "NONE",
  COMPANION_CARD: "COM",
  SUPPLEMENTARY_CARD: "SUP",
  NEW_CARD: "NEW",
};
